import React from "react";
import { DebounceInput, DebounceInputProps } from "react-debounce-input";
import TextInput, {
  ITextInput,
} from "components/common/ui/form-elements/text-input/TextField";

interface Props extends DebounceInputProps<HTMLInputElement, ITextInput> {
  debounceTimeout?: number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => any;
}

const DebouncedTextInput = (props: Props) => (
  <DebounceInput {...props} element={TextInput} />
);

export default DebouncedTextInput;
